import {useEffect, useState} from 'react';
import {EventEmitter} from 'eventemitter3';

const emitter = new EventEmitter();

export const useEventSubscription = (event, callback) => {
    const unsubscribe = () => {
        emitter.off(event, callback);
    };

    useEffect(() => {
        emitter.on(event, callback);
        return unsubscribe;
    });

    return unsubscribe;
};

export const useEventEmitter = () => {
    return (event, data) => {
        emitter.emit(event, data);
    };
};

export const emitEvent = (event, data) => {
    emitter.emit(event, data);
}


export function useBodyScrollLock() {
    const [locked, setLocked] = useState(false);
    
    useEffect(() => {
        if (locked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        
        // clean up on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [locked]);
    
    return [locked, setLocked];
}
